import { peopleLookEditRights } from 'modules/auth/constants';

const isViewOnly = (rights) => [peopleLookEditRights.view_only].includes(rights);
export const isCreateEditReport = (rights) => [peopleLookEditRights.create_edit_report].includes(rights);
export const isCreateEditReportTempalte = (rights) =>
  [peopleLookEditRights.create_edit_report_template].includes(rights);

export default isViewOnly;
